
<template>
  <div class="w-100 h-100" :style="backGroundColor" style="position: relative">
    <!-- ドラッグ出来ないようにdivで表示 -->
    <div
      ref="designImage"
      class="design"
      :style="getDesignImageStyle"
    />
    <div
      v-if="$store.state.designPreview.isShowCutline && $store.state.designPreview.cutlinePreviewMode == 0"
      ref="cutlineImage"
      class="cutline-fill"
      :style="getCutlineImageStyle"
    />
    <div
      v-if="$store.state.designPreview.isShowCutline && $store.state.designPreview.cutlinePreviewMode == 1"
      ref="cutline2Image"
      class="cutline-line"
      :style="getCutlineImage2Style"
    />
  </div>
</template>

<script>
import { PreviewColorList, GetCanvasSize } from "@/js/Const.js";
import { Logger } from '@/js/utils/Logger.js'

export default {
  name: "Preview2D",
  props: {},
  data: function () {
    return {
      canvas: null,
    };
  },
  watch: {
    // "$store.state.cutlineImageURL":async function(){
    //   let image = await CreateImageElement(this.$store.state.cutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // },
    // "$store.state.scFrameCutlineImageURL":async function(){
    //   let image = await CreateImageElement(this.$store.state.scFrameCutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // },
  },
  async created() {
    Logger.info("Preview2D created");

    this.canvas = this.$refs.canvas;

    // if( this.$store.state.cutlineImageURL ){
    //   let image = await CreateImageElement(this.$store.state.cutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // }

    // if( this.$store.state.scFrameCutlineImageURL ){
    //   let image = await CreateImageElement(this.$store.state.scFrameCutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // }
  },
  computed: {
    getDesignImageStyle() {
      let canvasSize = GetCanvasSize(this.$store.state.designPreview.selectProductId);
      return {
        "background-image": 'url("' + this.$store.state.designPreview.designImageURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    getCutlineImageStyle() {
      let canvasSize = GetCanvasSize(this.$store.state.designPreview.selectProductId);
      return {
        "background-image": 'url("' + this.$store.state.designPreview.originalCutlineImageURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    getCutlineImage2Style() {
      let canvasSize = GetCanvasSize(this.$store.state.designPreview.selectProductId);
      return {
        "background-image": 'url("' + this.$store.state.designPreview.cutlineContourImageURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    backGroundColor() {
      return {
        "background-color": PreviewColorList[this.$store.state.designPreview.selectBackgroundColor],
      };
    },
  },
  unmounted() {
    Logger.info("Preview2D unmounted");
  },
  mounted() {
    Logger.info("Preview2D mounted");
  },
  destroyed() {
    Logger.info("Preview2D destroyed");
  },

  components: {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.design {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.cutline-fill {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  opacity: 30%;
}

.cutline-line {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  opacity: 100%;
}
</style>
